




















import { Vue, Component } from "vue-property-decorator";
import { db } from "../main";
import firebase from "firebase";
import MatchList from "../components/MatchList.vue";
import { getModule } from "vuex-module-decorators";
import TripsModule from "../store/modules/trips";
import TripPreview from "@/components/TripPreview.vue";
//mport trips from "@/store/modules/trips"

const trips = getModule(TripsModule);

@Component({
  components: { MatchList, TripPreview }
})
export default class Trip extends Vue {
  created() {
    trips.bindTrips();
    //this.$store.dispatch('bindTrips');
    //trips.bindTrips();
  }

  get stops() {
    return trips.trips;
  }

  createStop() {
    this.$router.push("/trip/create");
  }

  deleteItem(trip: any) {
    debugger;
    this.$ionic.alertController
      .create({
        header: "Delete trip?",
        subHeader: trip.destination,
        message: "Are you sure you want to delete this trip?",
        buttons: [
          "Cancel",
          {
            text: "OK",
            role: "ok",
            handler: data => {
              trips.deleteTrip(trip);
              //this.$store.dispatch('deleteStop', stop);
            }
          }
        ]
      })
      .then(a => a.present());
  }

  showTrip(trip: any) {
    this.$router.push("/trip/" + trip.id) + "/";
  }
}
/*
export default {
  name: "trip",
  components: {
    MatchList
  },
  computed: {
    stops() {
      return this.$store.state.trips.stops;
    }
  },
  methods: {
    createStop: function() {
      this.$router.push("/trip/create");
    },
    
    deleteItem: function(stop) {  
      this.$ionic.alertController
        .create({
          header: "Delete place?",
          subHeader: stop.destination,
          message: "Are you sure you want to delete this entry?",
          buttons: [
            "Cancel",
            {
              text: "OK",
              role: "ok",
              handler: data => {
                this.$store.dispatch('deleteStop', stop);
              }
            }
          ]
        })
        .then(a => a.present());
    },
    showTrip: function(stop) {
      this.$router.push("/trip/" + stop.id) + "/";
    },
    refresh: function() {
      var currentUser = firebase.auth().currentUser;
      db.collection("trips" + currentUser.uid)
        .orderBy("startDate")
        .get()
        .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.stops.push({ id: doc.id, ...doc.data() });
        });
      });
    },
    image: async function(stop) {
      let url = await firebase.storage().ref('places_photos/' + stop.id).getDownloadURL();
      return url;
    }
  },
  created: function() {
    this.$store.dispatch('bindStops');
    //this.refresh();
  }
};
*/
